import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-0a7c60fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selection-detail" }
const _hoisted_2 = {
  key: 0,
  class: "volumes-panel"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex selection-detail-header" }, "Volume - Properties", -1))
const _hoisted_4 = { class: "volumes-scroll" }
const _hoisted_5 = {
  key: 0,
  class: "selection-empty d-flex justify-content-center align-items-center"
}
const _hoisted_6 = ["data-volume-card-id"]
const _hoisted_7 = { class: "volume-card-header" }
const _hoisted_8 = { class: "volume-header-main" }
const _hoisted_9 = { class: "volume-color-anchor" }
const _hoisted_10 = ["onClick", "title", "data-volume-id"]
const _hoisted_11 = ["onClick", "title"]
const _hoisted_12 = { class: "volume-title-block" }
const _hoisted_13 = { class: "header-actions" }
const _hoisted_14 = { class: "debug-buttons" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "volume-content" }
const _hoisted_19 = { class: "info-columns" }
const _hoisted_20 = { class: "info-col" }
const _hoisted_21 = { class: "info-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Fill:", -1))
const _hoisted_23 = { class: "info-row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Cut:", -1))
const _hoisted_25 = { class: "info-row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Total:", -1))
const _hoisted_27 = { class: "info-col" }
const _hoisted_28 = { class: "info-row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "3D area:", -1))
const _hoisted_30 = { class: "info-row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "2D area:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-row spacer" }, null, -1))
const _hoisted_33 = { class: "volume-description" }
const _hoisted_34 = { class: "volume-description-header" }
const _hoisted_35 = ["for"]
const _hoisted_36 = {
  key: 0,
  class: "volume-description-error"
}
const _hoisted_37 = {
  key: 1,
  class: "volume-description-saved"
}
const _hoisted_38 = {
  key: 1,
  class: "default-selection-panel"
}
const _hoisted_39 = {
  key: 0,
  class: "selection-empty d-flex text-center justify-content-center align-items-center"
}
const _hoisted_40 = {
  key: 1,
  class: "d-flex flex-column justify-content-strech"
}
const _hoisted_41 = { class: "d-flex selection-detail-header" }
const _hoisted_42 = { class: "selection-content" }
const _hoisted_43 = { class: "form-outline" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "annTitle"
}, "Title", -1))
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "form-outline" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "annDesc"
}, "Description", -1))
const _hoisted_48 = ["value"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_50 = {
  key: 1,
  class: "form-outline"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label flex-grow-1" }, "Displayed measurement", -1))
const _hoisted_52 = {
  key: 2,
  class: "form-outline"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label flex-grow-1" }, "Layer", -1))
const _hoisted_54 = {
  key: 3,
  class: "form-outline d-flex align-items-center"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label flex-grow-1" }, "Color", -1))
const _hoisted_56 = { class: "profile-colors-list" }
const _hoisted_57 = { class: "profile-color-item d-flex align-items-center" }
const _hoisted_58 = { class: "profile-name flex-grow-1" }
const _hoisted_59 = { class: "color-circle small" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_61 = { class: "profile-colors-list" }
const _hoisted_62 = { class: "profile-name flex-grow-1" }
const _hoisted_63 = { class: "color-circle small" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "Information", -1))
const _hoisted_67 = { class: "section-info d-flex flex-column" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "Vertical Scale", -1))
const _hoisted_70 = { class: "vertical-exaggeration-control" }
const _hoisted_71 = { class: "form-label d-flex align-items-center" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-grow-1" }, "Vertical exaggeration", -1))
const _hoisted_73 = { class: "exaggeration-value" }
const _hoisted_74 = { class: "slider-container" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider-labels" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1x"),
  /*#__PURE__*/_createElementVNode("span", null, "2x"),
  /*#__PURE__*/_createElementVNode("span", null, "3x")
], -1))
const _hoisted_76 = {
  key: 0,
  class: "slider-actions"
}

import { ElementType } from "@/classes/data-structures/element-type";
import { nextTick, onMounted, onUnmounted, reactive, ref, watch, computed } from "vue";
import { ColorPicker } from "vue-color-kit";
import { VueSelect } from "vue-select";
import { MeasurementType } from "@/classes/data-structures/measure-type";
import { Constants } from "@/classes/constants";
import { useAppStateStore } from "@/store/app-state";
import { LayerItemType } from "@/classes/data-structures/layer-item-type";
import { ViewIndex } from "@/classes/data-structures/view-index";
import { Utils } from "@/classes/utils/utils";
import { Profile } from "@/classes/viewer/profile";
import { LayerStatus } from "@/classes/data-structures/layer-status";
import { useDataStore } from "@/store/data-store";
import { useUserStore } from "@/store/user-store";
import InlineEditableText from "@/components/Viewer/InlineEditableText.vue";
import * as THREE from "three";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectionDetail',
  emits: ["onSelectedElementDeleted"],
  setup(__props, { emit }) {

const state = useAppStateStore();
const dataStore = useDataStore();
const userStore = useUserStore();

let updateTimeoutHandle: any = null;

let data = reactive({
  measurementOptionsForSelectedElement: [] as string[],
  selectedElement: null as any,
  selectedElementType: "none" as ElementType,
  selectedProfileGroup: null as any,
  selectedProfileForColorChange: null as any,
  showColorPicker: false,
  verticalExaggeration: 1.0,
  profileSelectionSet: [] as any[],
  lineInformation: {
    distance: 0,
    minElevation: 0,
    maxElevation: 0,
  },
});

const colorCircle = ref();
const heatmapTick = ref(0);
const hoveredVolumeId = ref<string | null>(null);
const volumeDescriptionDrafts = reactive<Record<string, string | undefined>>({});
const savedVolumeDescriptions = reactive<Record<string, boolean | undefined>>({});
const volumeDescriptionSaveErrors = reactive<Record<string, boolean | undefined>>({});
const savedVolumeDescriptionTimers = new Map<string, ReturnType<typeof setTimeout>>();

// ---------- Selection classification & UI model ----------
const isAnyProfileSelected = computed(() => data.profileSelectionSet.length > 0);
const isSingleProfile = computed(() => data.profileSelectionSet.length === 1);
const isMultiProfileSelection = computed(() => data.profileSelectionSet.length > 1);
const showResetButton = computed(() => data.profileSelectionSet.length > 1);

const color = computed(() => {
  const clr = data.selectedElement ? data.selectedElement.color : null;
  return clr ? "#" + clr.getHexString() : "";
});
const colorPickerStyle = computed(() => `background-color: ${color.value};`);
const cadLayerOptions = computed(() => state.getViewLayers(ViewIndex.View1, LayerItemType.Cad).map((l) => l.name));
const selectedTab = computed(() => state.getViewTab(ViewIndex.View1));
const canEditVolumeMetadata = computed(() => {
  const ownerUUID = state.project?.user?.uuid;
  const userUUID = userStore.state.user?.uuid;
  return !!ownerUUID && ownerUUID === userUUID;
});

const visibleVolumes = computed(() => {
  const layers = state.getViewLayers(ViewIndex.View1, LayerItemType.Volumes)
    .filter(l => l.visible && l.layerStatus === LayerStatus.ProcessedAndLoaded);
  const v = (window as any).viewer?.volumes || [];
  return layers
    .map(l => {
      const vol = v.find((x: any) => x.uuid === l.id);
      return vol ? { id: l.id, name: l.name, visible: l.visible, metadata: vol.userData?.metadata, obj: vol } : null;
    })
    .filter((x: any) => !!x);
});

function getProfileHeaderTitle() {
  if (isSingleProfile.value) return "Profile - Properties";
  if (isMultiProfileSelection.value) return `Multi-Selection - ${data.profileSelectionSet.length} Profiles`;
  return "Profile";
}
function getProfilesList() { return data.profileSelectionSet; }
function getSingleProfileData() { return data.profileSelectionSet.length > 0 ? data.profileSelectionSet[0] : null; }

// Unified UI descriptor for the current selection
const ui = computed(() => {
  const none = {
    hasSelection: false,
    headerTitle: "",
    deletable: false,
    showAnnotationFields: false,
    showDisplayedMeasurement: false,
    showLayer: false,
    showColorPickerGeneric: false,
    infoEntries: [] as { label: string; value: string }[],
  };

  const el = data.selectedElement;
  const type = data.selectedElementType;

  if (!el && !isAnyProfileSelected.value) return none;

  // Profiles (any profile selection takes precedence)
  if (isAnyProfileSelected.value) {
    const info: { label: string; value: string }[] = [];
    if (isSingleProfile.value && getSingleProfileData()) {
      const p = getSingleProfileData();
      info.push(
        { label: "Length (2D)", value: Utils.formatUnits(p.getTotalDistance(), p.unit) },
        { label: "Minimum elevation", value: Utils.formatUnits(p.getMinElevation(), p.unit) },
        { label: "Maximum elevation", value: Utils.formatUnits(p.getMaxElevation(), p.unit) }
      );
    }

    return {
      hasSelection: true,
      headerTitle: getProfileHeaderTitle(),
      deletable: isSingleProfile.value, // allow delete only for single scene-selected profile
      showAnnotationFields: false,
      showDisplayedMeasurement: false,
      showLayer: false,
      showColorPickerGeneric: false, // profiles manage color in their own blocks
      infoEntries: info,
    };
  }

  // Non-profile selections
  const uiBase = {
    hasSelection: true,
    headerTitle: "",
    deletable: true,
    showAnnotationFields: false,
    showDisplayedMeasurement: false,
    showLayer: false,
    showColorPickerGeneric: false,
    infoEntries: [] as { label: string; value: string }[],
  };

  if (type === "annotation") {
    return {
      ...uiBase,
      headerTitle: "Annotation - Properties",
      showAnnotationFields: true,
      showColorPickerGeneric: true,
    };
  }

  if (type === "point") {
    const p0 = el.getPointInTargetCoordinateSystem(0);
    return {
      ...uiBase,
      headerTitle: "Point - Properties",
      showLayer: true,
      showColorPickerGeneric: true,
      infoEntries: [
        { label: "x", value: `${p0.x.toFixed(Constants.measureFormattingDecimals)}${el.unit}` },
        { label: "y", value: `${p0.y.toFixed(Constants.measureFormattingDecimals)}${el.unit}` },
        { label: "z", value: `${p0.z.toFixed(Constants.measureFormattingDecimals)}${el.unit}` },
      ],
    };
  }

  if (type === "circle") {
    const c = el.getPointInTargetCoordinateSystem(0);
    return {
      ...uiBase,
      headerTitle: "Circle - Properties",
      showLayer: true,
      showColorPickerGeneric: true,
      infoEntries: [
        { label: "x", value: `${c.x.toFixed(Constants.measureFormattingDecimals)}${el.unit}` },
        { label: "y", value: `${c.y.toFixed(Constants.measureFormattingDecimals)}${el.unit}` },
        { label: "z", value: `${c.z.toFixed(Constants.measureFormattingDecimals)}${el.unit}` },
        { label: "radius", value: `${el.getRadius().toFixed(Constants.measureFormattingDecimals)} ${el.unit}` },
      ],
    };
  }

  if (type === "line") {
    // distinguish profile lines already handled above; this branch is for non-profile lines
    const info = [
      { label: "Length", value: Utils.formatUnits(data.lineInformation.distance, el.unit) },
      { label: "Minimum elevation", value: Utils.formatUnits(data.lineInformation.minElevation, el.unit) },
      { label: "Maximum elevation", value: Utils.formatUnits(data.lineInformation.maxElevation, el.unit) },
    ];

    return {
      ...uiBase,
      headerTitle: "Line - Properties",
      showDisplayedMeasurement: true,
      showLayer: true,
      showColorPickerGeneric: true,
      infoEntries: info,
    };
  }

  return none;
});

// ---------- Volume features ----------
// Color handling per volume card
const openPickers: any = reactive({});

function isVolumePickerOpen(id: string){
  return !!openPickers[id];
}

async function toggleVolumePicker(id: string){
  // If heatmap is enabled, disable it and switch to overlay mode (but don't open color picker)
  if (isHeatmapEnabled(id)) {
    const viewer: any = (window as any).viewer;
    if (viewer?.setVolumeHeatmapEnabled) {
      await viewer.setVolumeHeatmapEnabled(id, false);
      heatmapTick.value++;
    }
    // Hide diff mesh when switching from heatmap to overlay mode
    if (viewer?.setVolumeDebugVisibility) {
      viewer.setVolumeDebugVisibility(id, { before: true, after: true, diff: false });
    }
    openPickers[id] = false; // Don't open color picker when switching from heatmap to overlay

    // Notify layers component that heatmap state has changed
    window.dispatchEvent(new CustomEvent("volume-overlay-color-changed", { detail: { id } }));
  } else {
    // Close regular color picker when opening volume color picker
    data.showColorPicker = false;

    // Close all other volume color pickers
    for (const otherId in openPickers) {
      if (otherId !== id) {
        openPickers[otherId] = false;
      }
    }

    // If we're already in overlay mode and clicking overlay button, open color picker (don't toggle)
    openPickers[id] = true;
    nextTick(() => positionVolumeColorPicker(id));
  }
}

function getVolumeOverlayColor(id: string): string{
  const viewer: any = (window as any).viewer;
  const vol = viewer?.volumes?.find((v: any) => v.uuid === id);
  const poly = vol?.children?.find((c: any) => c.name === "SelectionPolygon");
  const hexValue = poly?.userData?.color ?? 0xff0000;
  const n = typeof hexValue === "number" ? hexValue : parseInt(String(hexValue).replace("#",""), 16);
  const hex = (n >>> 0).toString(16);
  return `#${"000000".substring(0, 6 - hex.length) + hex}`;
}

function volumeColorStyle(id: string){
  return `background-color: ${getVolumeOverlayColor(id)};`;
}

function onVolumeColorChange(id: string, color: any){
  const hex = `#${((1 << 24) + (color.rgba.r << 16) + (color.rgba.g << 8) + color.rgba.b).toString(16).slice(1)}`;
  const viewer: any = (window as any).viewer;
  viewer?.setVolumeOverlayColor(id, hex);
  heatmapTick.value++;

  // Notify layers component that volume color has changed
  window.dispatchEvent(new CustomEvent("volume-overlay-color-changed", { detail: { id, color: hex } }));
}

function isHeatmapEnabled(id: string): boolean {
  heatmapTick.value;
  const viewer: any = (window as any).viewer;
  return viewer?.isVolumeHeatmapEnabled?.(id) ?? false;
}

async function toggleHeatmap(id: string) {
  console.log("toggleHeatmap called with id:", id);
  const viewer: any = (window as any).viewer;

  if (!viewer?.setVolumeHeatmapEnabled || !viewer?.isVolumeHeatmapEnabled) {
    console.log("Heatmap methods not available on viewer");
    return;
  }

  const enabled = viewer.isVolumeHeatmapEnabled(id);
  console.log("Current heatmap enabled state:", enabled, "toggling to:", !enabled);

  try {
    await viewer.setVolumeHeatmapEnabled(id, !enabled);
    console.log("Heatmap toggle completed successfully");
  } catch (error) {
    console.error("Error toggling heatmap:", error);
  }

  // Close color picker if heatmap is being enabled
  if (!enabled) {
    openPickers[id] = false;
  }

  heatmapTick.value++;

  // Notify layers component that heatmap state has changed
  window.dispatchEvent(new CustomEvent("volume-overlay-color-changed", { detail: { id } }));
}

function heatmapDotClass(id: string): string {
  const classes = ["heatmap-dot"] as string[];
  if (isHeatmapEnabled(id)) {
    classes.push("active");
  }
  return classes.join(" ");
}

function heatmapTooltip(id: string): string {
  return isHeatmapEnabled(id) ? "Disable heatmap overlay" : "Show cut/fill heatmap";
}

function getVolumeChildVisibility(id: string, childType: "before" | "after" | "diff"): boolean {
  heatmapTick.value; // Force reactivity dependency
  const viewer: any = (window as any).viewer;
  return viewer?.getVolumeChildVisibility?.(id, childType) ?? true;
}

function toggleVolumeChildVisibility(id: string, childType: "before" | "after" | "diff") {
  const viewer: any = (window as any).viewer;
  if (viewer?.toggleVolumeChildVisibility) {
    viewer.toggleVolumeChildVisibility(id, childType);
    // Force reactivity update to refresh the UI
    heatmapTick.value++;
  }
}

function toggleVolumeVisibility(id: string){
  state.toggleLayer(id, LayerItemType.Volumes, ViewIndex.View1);
}

function zoomToVolume(id: string){
  const layer = state.getViewLayers(ViewIndex.View1, LayerItemType.Volumes).find(l => l.id === id);
  const viewer = (window as any).viewer;
  if (layer && viewer) {
    viewer.zoomToFitLayer(layer);
  }
}

function format3(value: any): string {
  if (value === null || value === undefined) return "-";
  const n = Number(value);
  if (!isFinite(n)) return "-";
  return n.toFixed(3);
}

function getViewerUnit(): string {
  const viewer: any = (window as any).viewer;
  return viewer?.getUnit?.() || "m";
}

function formatUnitPower(unit: string, power: 2 | 3): string {
  const suffix = power === 2 ? "²" : "³";
  return `${unit}${suffix}`;
}

function formatValueWithUnit(value: any, unit: string): string {
  const formatted = format3(value);
  return formatted === "-" ? formatted : `${formatted} ${unit}`;
}

function formatAreaValue(value: any): string {
  return formatValueWithUnit(value, formatUnitPower(getViewerUnit(), 2));
}

function formatVolumeValue(value: any): string {
  return formatValueWithUnit(value, formatUnitPower(getViewerUnit(), 3));
}

function getSavedVolumeName(volume: any): string {
  const savedName = typeof volume.metadata?.name === "string" ? volume.metadata.name : volume.name;
  return (typeof savedName === "string" ? savedName.trim() : "") || "Volume";
}

function getVolumeDescription(volume: any): string {
  return volumeDescriptionDrafts[volume.id] ?? (typeof volume.metadata?.description === "string" ? volume.metadata.description : "");
}

function applyVolumeMetadataLocally(volume: any, metadata: { name?: string; description?: string }): void {
  if (volume?.obj) {
    volume.obj.userData = volume.obj.userData || {};
    volume.obj.userData.metadata = volume.obj.userData.metadata || {};
    Object.assign(volume.obj.userData.metadata, metadata);

    if (metadata.name !== undefined) {
      volume.obj.name = metadata.name;
      const selectionPolygon = volume.obj.children?.find((child: any) => child.name === "SelectionPolygon");
      selectionPolygon?.userData?.areaLabel?.setText?.(metadata.name);
      volume.obj.userData?.areaLabel3D?.setText?.(metadata.name);

      const layer = state.getViewLayers(ViewIndex.View1, LayerItemType.Volumes).find((item) => item.id === volume.id);
      if (layer) {
        layer.name = metadata.name;
      }
    }
  }

  const surveyVolume = state.view1Survey?.volumes?.find((item: any) => item.uuid === volume.id);
  if (surveyVolume) {
    if (metadata.name !== undefined) {
      surveyVolume.name = metadata.name;
    }
    surveyVolume.additionalData = { ...((surveyVolume.additionalData as any) || {}), ...metadata } as any;
  }
}

async function saveVolumeMetadata(
  volume: any,
  metadata: { name?: string; description?: string },
): Promise<boolean> {
  const surveyUUID = state.view1Survey?.uuid;
  if (!surveyUUID) {
    return false;
  }

  try {
    const success = await dataStore.updateVolumeMetadata(surveyUUID, volume.id, metadata);
    if (success) {
      applyVolumeMetadataLocally(volume, metadata);
    }
    return success;
  } catch (err) {
    console.error("Error saving volume metadata:", err);
  }

  return false;
}

async function saveVolumeName(volume: any, nextName: string): Promise<void> {
  const normalizedName = typeof nextName === "string" ? nextName.trim() : "";
  if (!normalizedName || normalizedName === getSavedVolumeName(volume)) {
    return;
  }

  await saveVolumeMetadata(volume, { name: normalizedName });
}

async function saveVolumeDescription(volume: any, nextDescription: string): Promise<void> {
  const description = typeof nextDescription === "string" ? nextDescription : "";
  const savedDescription = typeof volume.metadata?.description === "string" ? volume.metadata.description : "";
  if (description === savedDescription) {
    volumeDescriptionDrafts[volume.id] = undefined;
    return;
  }

  const success = await saveVolumeMetadata(volume, { description });
  if (success) {
    const existingTimer = savedVolumeDescriptionTimers.get(volume.id);
    if (existingTimer) {
      clearTimeout(existingTimer);
    }

    volumeDescriptionDrafts[volume.id] = undefined;
    volumeDescriptionSaveErrors[volume.id] = undefined;
    savedVolumeDescriptions[volume.id] = true;
    const timer = setTimeout(() => {
      savedVolumeDescriptions[volume.id] = undefined;
      savedVolumeDescriptionTimers.delete(volume.id);
    }, 2000);
    savedVolumeDescriptionTimers.set(volume.id, timer);
  } else {
    savedVolumeDescriptions[volume.id] = undefined;
    volumeDescriptionSaveErrors[volume.id] = true;
  }
}

function onVolumeDescriptionInput(volume: any, nextValue: string): void {
  const existingTimer = savedVolumeDescriptionTimers.get(volume.id);
  if (existingTimer) {
    clearTimeout(existingTimer);
    savedVolumeDescriptionTimers.delete(volume.id);
  }
  savedVolumeDescriptions[volume.id] = undefined;
  volumeDescriptionSaveErrors[volume.id] = undefined;
  volumeDescriptionDrafts[volume.id] = typeof nextValue === "string" ? nextValue : "";
}

function onVolumeHover(volumeId: string | null) {
  hoveredVolumeId.value = volumeId;
  if (volumeId && selectedTab.value === LayerItemType.Volumes) {
    nextTick(() => {
      const card = document.querySelector(`[data-volume-card-id="${volumeId}"]`);
      if (card) {
        card.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    });
  }
}

function positionVolumeColorPicker(volumeId: string) {
  const trigger = document.querySelector(`[data-volume-id="${volumeId}"]`);
  const picker = trigger?.querySelector(".color-picker");
  if (!trigger || !picker) return;

  const triggerRect = trigger.getBoundingClientRect();
  const pickerEl = picker as HTMLElement;
  const pickerRect = pickerEl.getBoundingClientRect();
  const pickerWidth = pickerRect.width || pickerEl.offsetWidth || 220;
  const pickerHeight = pickerRect.height || pickerEl.offsetHeight || 280;
  const margin = 8;

  let left = triggerRect.right + margin;
  let top = triggerRect.top;

  // Check if picker would go off right edge of viewport
  if (left + pickerWidth > window.innerWidth) {
    left = triggerRect.left - pickerWidth - margin;
  }

  // Check if picker would go off bottom edge of viewport
  if (top + pickerHeight > window.innerHeight) {
    top = window.innerHeight - pickerHeight - margin;
  }

  // Check if picker would go off top edge of viewport
  if (top < margin) {
    top = margin;
  }

  // Check if picker would go off left edge of viewport
  if (left < margin) {
    left = margin;
  }

  pickerEl.style.left = `${left}px`;
  pickerEl.style.top = `${top}px`;
}

function hideVolumeColorPickers(event: any) {
  // Check if click is outside any volume color picker
  const target = event.target as Element;
  const isInsideVolumePicker = target.closest(".overlay-color-dot") || target.closest(".color-picker");

  if (!isInsideVolumePicker) {
    // Close all volume color pickers
    for (const id in openPickers) {
      openPickers[id] = false;
    }
  }
}

// ---------- Profile color helpers ----------
function openColorPickerForProfile(profile: any) {
  if (data.selectedProfileForColorChange && data.selectedProfileForColorChange.uuid === profile.uuid) {
    data.selectedProfileForColorChange = null;
    return;
  }
  data.showColorPicker = false;
  data.selectedProfileForColorChange = profile;
}
function toggleColorPicker() {
  data.showColorPicker = !data.showColorPicker;

  if (data.showColorPicker) {
    // Close all volume color pickers when opening regular color picker
    for (const id in openPickers) {
      openPickers[id] = false;
    }
  }
}
function hideColorPicker(event?: Event) {
  if (!event) { data.showColorPicker = false; data.selectedProfileForColorChange = null; return; }
  const target = event.target as HTMLElement | null;
  if (!target) { data.showColorPicker = false; data.selectedProfileForColorChange = null; return; }
  const withinCircle = target.closest(".color-circle");
  const withinPicker = target.closest(".color-picker");
  if (withinCircle || withinPicker) return;
  data.showColorPicker = false;
  data.selectedProfileForColorChange = null;
}
function changeProfileColor(color: any) {
  if (data.selectedProfileForColorChange) {
    const hexColor = `#${color.rgba.r.toString(16).padStart(2, "0")}${color.rgba.g.toString(16).padStart(2, "0")}${color.rgba.b.toString(16).padStart(2, "0")}`;
    data.selectedProfileForColorChange.setColorFromHex(hexColor);
    document.dispatchEvent(new CustomEvent("profile-color-changed"));
  }
}

function applyColorToElement(element: any, hexColor: string) {
  const nextColor = new THREE.Color(hexColor);
  const prototype = Object.getPrototypeOf(element);
  const colorDescriptor = prototype ? Object.getOwnPropertyDescriptor(prototype, "color") : undefined;
  const hasColorSetter = typeof colorDescriptor?.set === "function";

  if (hasColorSetter) {
    // Respect class-specific color setters (e.g. UnifiedLineMeasure, Annotation).
    element.color = nextColor;
    return;
  }

  if (element.color && typeof element.color.copy === "function") {
    element.color.copy(nextColor);
  } else {
    element.color = nextColor;
  }

  // CAD measurements need an explicit refresh after color mutation.
  if (typeof element.updateVisuals === "function") {
    element.updateVisuals();
  } else if (typeof element.update === "function") {
    element.update();
  }
}

function changeColor(color: any) {
  const hexColor = `#${color.rgba.r.toString(16).padStart(2, "0")}${color.rgba.g.toString(16).padStart(2, "0")}${color.rgba.b.toString(16).padStart(2, "0")}`;
  if (isAnyProfileSelected.value && isSingleProfile.value) {
    const profileData = getSingleProfileData();
    profileData.setColorFromHex(hexColor);
    document.dispatchEvent(new CustomEvent("profile-color-changed"));
  } else if (data.selectedElement && data.selectedElement.color) {
    applyColorToElement(data.selectedElement, hexColor);
  }
}

// ---------- Selection plumbing ----------
function findProfileGroupByLayerItem(layerItem: any) {
  if (!layerItem) return null;
  const viewer = (window as any).viewer;
  if (!viewer?.profiles) return null;
  const groupProfiles: any[] = [];
  if (layerItem.children) {
    layerItem.children.forEach((child: any) => {
      const profile = viewer.profiles.find((p: any) => p.uuid === child.id || p.name === child.name);
      if (profile) groupProfiles.push(profile);
    });
  }
  return { name: layerItem.name, profiles: groupProfiles.sort((a: any, b: any) => a.name.localeCompare(b.name)) };
}

function updateProfileSelectionSet() {
  data.profileSelectionSet = [];
  if (data.selectedElement && data.selectedElementType === "line" && data.selectedElement instanceof Profile) {
    data.profileSelectionSet = [data.selectedElement];
    return;
  }
  if (data.selectedElement && (data.selectedElement as any)?.isProfile) {
    data.profileSelectionSet = [data.selectedElement];
    return;
  }
  if (data.selectedElement && (data.selectedElement as any)?.isMultiProfileSelection) {
    data.profileSelectionSet = data.selectedElement.profiles || [];
    return;
  }
  if (data.selectedProfileGroup && data.selectedProfileGroup.profiles) {
    data.profileSelectionSet = data.selectedProfileGroup.profiles;
    return;
  }
  if (data.selectedElement && typeof (data.selectedElement as any)?.getColorHex === "function" && typeof (data.selectedElement as any)?.getTotalDistance === "function") {
    data.profileSelectionSet = [data.selectedElement];
    return;
  }
}

function onSelectionChanged() {
  const element = state.selectedElement;
  nextTick(() => {
    data.selectedElement = element;
    data.selectedElementType = data.selectedElement ? data.selectedElement.elementType : "none";

    if (data.selectedElement && (data.selectedElement as any)?.isProfileGroup) {
      data.selectedProfileGroup = findProfileGroupByLayerItem(data.selectedElement.layerItem);
    } else {
      data.selectedProfileGroup = null;
    }

    updateProfileSelectionSet();

    const isProfileSelection = (
      data.selectedElement && (
        (data.selectedElementType === "line" && data.selectedElement instanceof Profile) ||
        (data.selectedElement as any)?.isMultiProfileSelection ||
        (data.selectedElement as any)?.isProfileGroup
      )
    ) || data.profileSelectionSet.length > 0;

    if (isProfileSelection) {
      data.verticalExaggeration = 1.0;
      onVerticalExaggerationChanged();
    }

    if (data.selectedElementType === "line" && !(data.selectedElement instanceof Profile)) {
      updateSelectedElementInformation();
      data.measurementOptionsForSelectedElement = [MeasurementType.Distance2D, MeasurementType.Distance3D];
      const pointCount = data.selectedElement.points.length;
      if (pointCount > 2) {
        data.measurementOptionsForSelectedElement.push(MeasurementType.Area2D, MeasurementType.Area3D);
      }
      if (pointCount > 1) {
        data.measurementOptionsForSelectedElement.push(MeasurementType.Height, MeasurementType.Angle);
      }
    }

    data.showColorPicker = false;
    data.selectedProfileForColorChange = null;
  });
}

function updateSelectedElementInformation() {
  if (data.selectedElementType === "line" && !(data.selectedElement instanceof Profile)) {
    data.lineInformation.distance = data.selectedElement.getTotalDistance();
    data.lineInformation.minElevation = Number.MAX_VALUE;
    data.lineInformation.maxElevation = Number.MIN_VALUE;
    for (let i = 0; i < data.selectedElement.points.length; i++) {
      console.log("point", i, data.selectedElement);
      const p = data.selectedElement.getPointInTargetCoordinateSystem(i);
      if (p.z < data.lineInformation.minElevation) data.lineInformation.minElevation = p.z;
      if (p.z > data.lineInformation.maxElevation) data.lineInformation.maxElevation = p.z;
    }
  }
}

// ---------- Basic field handlers ----------
function onTitleChanged(event: any) { if (data.selectedElement) state.updateElementName(data.selectedElement, event.target.value, ViewIndex.View1); }
function onDescriptionChanged(event: any) { if (data.selectedElement) data.selectedElement.description = event.target.value; }
function onSelectedElementLayerChanged(newLayerName: string) {
  data.selectedElement.layerName = newLayerName;
  const layer = state.getViewLayers(ViewIndex.View1, LayerItemType.Cad).find((l) => l.name == newLayerName);
  if (layer) {
    data.selectedElement.visible = layer.visible;
    state.setActiveCadLayer(layer);
  }
}
function onSelectedElementMeasurementRemoved(measurement: MeasurementType) {
  if (data.selectedElementType === "line") {
    const measurements = data.selectedElement.displayedMeasurements as MeasurementType[];
    const index = measurements.indexOf(measurement);
    if (index >= 0) measurements.splice(index, 1);
    data.selectedElement.displayedMeasurements = measurements;
  }
}
function onSelectedElementMeasurementChanged(measurements: MeasurementType[]) {
  if (data.selectedElementType === "line") data.selectedElement.displayedMeasurements = measurements;
}
function deleteSelected() { if (data.selectedElement) emit("onSelectedElementDeleted"); }

// ---------- Profile exaggeration ----------
function onVerticalExaggerationChanged() {
  document.dispatchEvent(new CustomEvent("profile-vertical-exaggeration-changed", { detail: { exaggeration: data.verticalExaggeration } }));
}
function resetVerticalExaggeration() { data.verticalExaggeration = 1.0; onVerticalExaggerationChanged(); }

// ---------- Key / lifecycle ----------
function handleEscapeKey(event: KeyboardEvent) {
  if (event.key === "Escape") {
    if (data.profileSelectionSet.length > 0) {
      state.selectedElement = null;
      const viewer = (window as any).viewer;
      if (viewer) viewer.clearProfileMultiSelection?.();
      data.selectedElement = null;
      data.selectedElementType = "none";
      data.selectedProfileGroup = null;
      data.profileSelectionSet = [];
      data.showColorPicker = false;
      data.selectedProfileForColorChange = null;
      setTimeout(() => { document.dispatchEvent(new CustomEvent("profile-deselected")); }, 5);
    }
  }
}

onMounted(() => {
  watch(() => state.selectedElement, onSelectionChanged);
  window.addEventListener("click", hideColorPicker, true);
  window.addEventListener("click", hideVolumeColorPickers, true);
  window.addEventListener("keydown", handleEscapeKey);
  updateTimeoutHandle = setInterval(updateSelectedElementInformation, 1000);

  // Listen to volume hover events from viewer
  const viewer = (window as any).viewer;
  if (viewer && viewer.onVolumeHover) {
    viewer.onVolumeHover.addListener(onVolumeHover);
  }
});

onUnmounted(() => {
  if (updateTimeoutHandle) { clearInterval(updateTimeoutHandle); updateTimeoutHandle = null; }
  window.removeEventListener("click", hideColorPicker, true);
  window.removeEventListener("click", hideVolumeColorPickers, true);
  window.removeEventListener("keydown", handleEscapeKey);

  // Remove volume hover listener
  const viewer = (window as any).viewer;
  if (viewer && viewer.onVolumeHover) {
    viewer.onVolumeHover.removeListener(onVolumeHover);
  }

  for (const timer of savedVolumeDescriptionTimers.values()) {
    clearTimeout(timer);
  }
  savedVolumeDescriptionTimers.clear();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(selectedTab) === _unref(LayerItemType).Volumes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_unref(visibleVolumes).length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No visible volumes. "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleVolumes), (vol) => {
              return (_openBlock(), _createElementBlock("div", {
                key: vol.id,
                class: _normalizeClass(['volume-card', { 'hovered': vol.id === hoveredVolumeId.value }]),
                "data-volume-card-id": vol.id
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['overlay-color-dot', { active: !isHeatmapEnabled(vol.id) }]),
                        style: _normalizeStyle(volumeColorStyle(vol.id)),
                        onClick: _withModifiers(($event: any) => (toggleVolumePicker(vol.id)), ["stop"]),
                        title: isHeatmapEnabled(vol.id) ? 'Switch to color overlay' : 'Change color',
                        "data-volume-id": vol.id
                      }, [
                        (isVolumePickerOpen(vol.id))
                          ? (_openBlock(), _createBlock(_unref(ColorPicker), {
                              key: 0,
                              class: "color-picker volume-color-picker",
                              color: getVolumeOverlayColor(vol.id),
                              onChangeColor: (c)=>onVolumeColorChange(vol.id, c)
                            }, null, 8, ["color", "onChangeColor"]))
                          : _createCommentVNode("", true)
                      ], 14, _hoisted_10),
                      _createElementVNode("div", {
                        class: _normalizeClass(heatmapDotClass(vol.id)),
                        onClick: _withModifiers(($event: any) => (toggleHeatmap(vol.id)), ["stop"]),
                        title: heatmapTooltip(vol.id)
                      }, null, 10, _hoisted_11)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(InlineEditableText, {
                        "max-length": 120,
                        "model-value": getSavedVolumeName(vol),
                        readonly: !_unref(canEditVolumeMetadata),
                        title: _unref(canEditVolumeMetadata) ? `Rename ${getSavedVolumeName(vol)}` : '',
                        onSave: ($event: any) => (saveVolumeName(vol, $event))
                      }, null, 8, ["model-value", "readonly", "title", "onSave"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['debug-button', { active: getVolumeChildVisibility(vol.id, 'before') }]),
                        onClick: _withModifiers(($event: any) => (toggleVolumeChildVisibility(vol.id, 'before')), ["stop"]),
                        title: "Toggle before mesh"
                      }, "B", 10, _hoisted_15),
                      _createElementVNode("div", {
                        class: _normalizeClass(['debug-button', { active: getVolumeChildVisibility(vol.id, 'after') }]),
                        onClick: _withModifiers(($event: any) => (toggleVolumeChildVisibility(vol.id, 'after')), ["stop"]),
                        title: "Toggle after mesh"
                      }, "A", 10, _hoisted_16)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(['layer-visibility', 'volume-visibility-toggle', vol.visible ? 'visible' : '']),
                      onClick: _withModifiers(($event: any) => (toggleVolumeVisibility(vol.id)), ["stop"]),
                      title: "Toggle visibility"
                    }, null, 10, _hoisted_17)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", null, _toDisplayString(formatVolumeValue(vol.metadata?.fill)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("div", null, _toDisplayString(formatVolumeValue(vol.metadata?.cut)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", null, _toDisplayString(formatVolumeValue(vol.metadata?.total)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", null, _toDisplayString(formatAreaValue(vol.metadata?.area3d)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("div", null, _toDisplayString(formatAreaValue(vol.metadata?.area2d)), 1)
                      ]),
                      _hoisted_32
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("label", {
                        class: "volume-description-label",
                        for: `volume-description-${vol.id}`
                      }, "Description", 8, _hoisted_35),
                      (volumeDescriptionSaveErrors[vol.id])
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, "ERROR SAVING"))
                        : (savedVolumeDescriptions[vol.id])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Saved"))
                          : _createCommentVNode("", true)
                    ]),
                    _createVNode(InlineEditableText, {
                      "input-id": `volume-description-${vol.id}`,
                      multiline: "",
                      rows: 3,
                      placeholder: _unref(canEditVolumeMetadata) ? 'Add volume description' : 'No description',
                      "model-value": getVolumeDescription(vol),
                      readonly: !_unref(canEditVolumeMetadata),
                      "onUpdate:modelValue": ($event: any) => (onVolumeDescriptionInput(vol, $event)),
                      onSave: ($event: any) => (saveVolumeDescription(vol, $event))
                    }, null, 8, ["input-id", "placeholder", "model-value", "readonly", "onUpdate:modelValue", "onSave"])
                  ])
                ])
              ], 10, _hoisted_6))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_38, [
          (!_unref(ui).hasSelection)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, " Select a cad item, profile or annotation to show properties. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createTextVNode(_toDisplayString(_unref(ui).headerTitle) + " ", 1),
                  (_unref(ui).deletable)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "delete-button",
                        src: _imports_0,
                        onClick: deleteSelected
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  (_unref(ui).showAnnotationFields)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _createElementVNode("input", {
                            id: "annTitle",
                            type: "text",
                            class: "form-control",
                            value: _unref(data).selectedElement.title,
                            onInput: onTitleChanged
                          }, null, 40, _hoisted_45)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("textarea", {
                            id: "annDesc",
                            type: "text",
                            class: "form-control",
                            value: _unref(data).selectedElement.description,
                            onInput: onDescriptionChanged
                          }, null, 40, _hoisted_48)
                        ]),
                        _hoisted_49
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(ui).showDisplayedMeasurement)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _hoisted_51,
                        _createVNode(_unref(VueSelect), {
                          class: "underlined",
                          multiple: true,
                          clearable: true,
                          modelValue: _unref(data).selectedElement.displayedMeasurements,
                          options: _unref(data).measurementOptionsForSelectedElement,
                          "onOption:deselected": _cache[0] || (_cache[0] = ($event: any) => (onSelectedElementMeasurementRemoved($event))),
                          "onOption:selected": _cache[1] || (_cache[1] = ($event: any) => (onSelectedElementMeasurementChanged($event)))
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(ui).showLayer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _hoisted_53,
                        _createVNode(_unref(VueSelect), {
                          class: "underlined",
                          clearable: false,
                          modelValue: _unref(data).selectedElement.layerName,
                          options: _unref(cadLayerOptions),
                          "onOption:selected": _cache[2] || (_cache[2] = ($event: any) => (onSelectedElementLayerChanged($event)))
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(ui).showColorPickerGeneric)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        _hoisted_55,
                        _createElementVNode("div", {
                          ref_key: "colorCircle",
                          ref: colorCircle,
                          class: "color-circle"
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["circle-btn", { active: _unref(data).showColorPicker }]),
                            style: _normalizeStyle(_unref(colorPickerStyle)),
                            onClick: toggleColorPicker
                          }, null, 6),
                          (_unref(data).showColorPicker)
                            ? (_openBlock(), _createBlock(_unref(ColorPicker), {
                                key: 0,
                                class: "color-picker",
                                onChangeColor: changeColor
                              }))
                            : _createCommentVNode("", true)
                        ], 512)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(isAnyProfileSelected))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        (_unref(isSingleProfile))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("div", _hoisted_57, [
                                  _createElementVNode("span", _hoisted_58, _toDisplayString(getSingleProfileData()?.name), 1),
                                  _createElementVNode("div", _hoisted_59, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["circle-btn", { active: _unref(data).showColorPicker }]),
                                      style: _normalizeStyle(`background-color: #${getSingleProfileData()?.getColorHex()}`),
                                      onClick: toggleColorPicker
                                    }, null, 6),
                                    (_unref(data).showColorPicker)
                                      ? (_openBlock(), _createBlock(_unref(ColorPicker), {
                                          key: 0,
                                          class: "color-picker",
                                          onChangeColor: changeColor,
                                          color: `#${getSingleProfileData()?.getColorHex()}`
                                        }, null, 8, ["color"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _hoisted_60
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_61, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getProfilesList(), (profile) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: profile.uuid,
                                    class: "profile-color-item d-flex align-items-center"
                                  }, [
                                    _createElementVNode("span", _hoisted_62, _toDisplayString(profile.name), 1),
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["circle-btn", { active: _unref(data).selectedProfileForColorChange && _unref(data).selectedProfileForColorChange.uuid === profile.uuid }]),
                                        style: _normalizeStyle(`background-color: #${profile.getColorHex()}`),
                                        onClick: ($event: any) => (openColorPickerForProfile(profile))
                                      }, null, 14, _hoisted_64),
                                      (_unref(data).selectedProfileForColorChange && _unref(data).selectedProfileForColorChange.uuid === profile.uuid)
                                        ? (_openBlock(), _createBlock(_unref(ColorPicker), {
                                            key: 0,
                                            class: "color-picker",
                                            onChangeColor: changeProfileColor,
                                            color: `#${_unref(data).selectedProfileForColorChange.getColorHex()}`
                                          }, null, 8, ["color"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ]),
                              _hoisted_65
                            ], 64))
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(ui).infoEntries.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _hoisted_66,
                        _createElementVNode("div", _hoisted_67, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ui).infoEntries, (row) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: row.label
                            }, [
                              _createElementVNode("div", null, _toDisplayString(row.label), 1),
                              _createElementVNode("div", null, _toDisplayString(row.value), 1)
                            ]))
                          }), 128))
                        ]),
                        _hoisted_68
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(isAnyProfileSelected))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        _hoisted_69,
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("label", _hoisted_71, [
                            _hoisted_72,
                            _createElementVNode("span", _hoisted_73, _toDisplayString(_unref(data).verticalExaggeration) + "x", 1)
                          ]),
                          _createElementVNode("div", _hoisted_74, [
                            _withDirectives(_createElementVNode("input", {
                              type: "range",
                              class: "vertical-exaggeration-slider",
                              min: "1",
                              max: "3",
                              step: "1",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(data).verticalExaggeration) = $event)),
                              onInput: onVerticalExaggerationChanged
                            }, null, 544), [
                              [
                                _vModelText,
                                _unref(data).verticalExaggeration,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _hoisted_75
                          ]),
                          (_unref(showResetButton))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                _createElementVNode("button", {
                                  class: "btn-small",
                                  onClick: resetVerticalExaggeration
                                }, "Reset")
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]))
        ]))
  ]))
}
}

})